import styled from 'styled-components';

export const StyledMainPage = styled.div`
  height: 100%;

  .loading {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translateX(-50%) translateY(-50%);
  }
`;

export const ControlsGroup = styled.div`
    position: absolute;
    right: 0px;
    bottom: 30px;
    display: inline-flex;
    align-items: center;

  > .muteAllButton,
  > .settingPopoverButton {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background-color: #232323;
    border-radius: 50%;
    width: 48px;
    height: 48px;
    margin-left: 8px;
    cursor: pointer;
    color: #fff;
  }

  > .muteAllButton{
    width: 100px;
    padding: 12px 18px;
    border-radius: 24px;
    font-size: 16px;
  }
`;


export const OnebookFrame = styled.iframe`
  width: 100%;
  height: 100%;
  position: absolute;
  z-index: ${({ isSelectMode }) => isSelectMode ? 100 : -1};
  opacity: ${({ isSelectMode }) => isSelectMode ? 1 : 0};
`;